import request from '@/utils/request'
const BASE_URL = '/TeMouldBom'

//系统
export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  getList(data) {
    return request({
      url: BASE_URL + '/BomList',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/GetInfo',
      method: 'get',
      params: { id }
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  change(data){
    return request({
      url: BASE_URL + '/Change',
      method: 'post',
      data
    })
  },
  review(id) {
    return request({
      url: BASE_URL + '/Review',
      method: 'get',
      params: { id }
    })
  },
  back(id) {
    return request({
      url: BASE_URL + '/Back',
      method: 'get',
      params: { id }
    })
  },
  bomList(data){
    return request({
      url: BASE_URL + '/bomList',
      method: 'post',
      data
    })
  },
  copy(data) {
    return request({
      url: BASE_URL + '/Copy',
      method: 'post',
      data
    })
  },
  delete(data) {
   
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data
    })
  },

}